import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => (
  <div className="legal-page">
    <div className="container">
      <h1>Privacy Policy</h1>
      <p className="legal-effective">Effective Date: February 17, 2026</p>
      <p>Solace Care 360 ("we," "our," or "us") is committed to protecting your privacy and maintaining the confidentiality of the information you share with us. This Privacy Policy explains how we collect, use, and safeguard information through our website and services.</p>

      <h2>Information We Collect</h2>
      <p>We may collect the following types of information:</p>
      <h3>A. Information You Provide</h3>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Organization or practice name</li>
        <li>Information submitted through contact forms</li>
        <li>Information provided when scheduling consultations</li>
      </ul>
      <h3>B. Automatically Collected Information</h3>
      <p>When you visit our website, we may automatically collect:</p>
      <ul>
        <li>IP address</li>
        <li>Browser type</li>
        <li>Device information</li>
        <li>Pages visited</li>
        <li>Time spent on pages</li>
        <li>Referral sources</li>
      </ul>
      <p>This information helps us improve website functionality and user experience.</p>

      <h2>How We Use Your Information</h2>
      <p>We use collected information to:</p>
      <ul>
        <li>Respond to inquiries</li>
        <li>Schedule consultations</li>
        <li>Provide information about our services</li>
        <li>Improve our website and service offerings</li>
        <li>Communicate updates relevant to our practice partners</li>
        <li>Maintain security and prevent misuse</li>
      </ul>
      <p>We do not sell or rent personal information to third parties.</p>

      <h2>Healthcare Information & HIPAA</h2>
      <p>Solace Care 360 provides nurse-led care management services in partnership with healthcare practices.</p>
      <p>Any protected health information (PHI) handled as part of our contracted services is managed in compliance with applicable federal and state regulations, including the Health Insurance Portability and Accountability Act (HIPAA).</p>
      <p>This website is not intended for the submission of protected health information unless through a secure, encrypted platform designated for that purpose.</p>

      <h2>Cookies & Analytics</h2>
      <p>Our website may use cookies and third-party analytics tools (such as Google Analytics) to:</p>
      <ul>
        <li>Understand visitor behavior</li>
        <li>Improve website performance</li>
        <li>Enhance user experience</li>
      </ul>
      <p>You may adjust your browser settings to disable cookies if preferred.</p>

      <h2>Data Security</h2>
      <p>We implement reasonable administrative, technical, and physical safeguards to protect information against unauthorized access, disclosure, alteration, or destruction.</p>
      <p>While we take appropriate security measures, no internet transmission is completely secure. Users submit information at their own discretion.</p>

      <h2>Third-Party Links</h2>
      <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of those sites.</p>

      <h2>Children's Privacy</h2>
      <p>Our website and services are not directed to individuals under the age of 18. We do not knowingly collect information from minors.</p>

      <h2>Your Rights</h2>
      <p>Depending on your location, you may have rights regarding your personal information, including:</p>
      <ul>
        <li>Access to information collected</li>
        <li>Request correction</li>
        <li>Request deletion</li>
        <li>Opt-out of marketing communications</li>
      </ul>
      <p>Requests may be submitted to the contact information below.</p>

      <h2>Updates to This Policy</h2>
      <p>We may update this Privacy Policy periodically. Updates will be posted on this page with a revised effective date.</p>

      <h2>Contact Us</h2>
      <p>If you have questions or concerns about Solace Care 360's Privacy Policy, please contact us at: <a href="mailto:contact@solacecare360.com">contact@solacecare360.com</a></p>
    </div>
  </div>
);

export default PrivacyPolicy;
